import createReactComponent from '../createReactComponent';
export default createReactComponent('letter-f', 'LetterF', [["path",{"d":"M15.5 7H9.25v5m0 0v5m0-5h5","key":"svg-0"}]]);